import React from "react";
import { CommonCard } from "../../Theme";
import { Grid } from "@mui/material";
import { Typography } from "@mui/material";
import { Box } from "@mui/material";
import PharmacyProfileIcon from "../../images/icons/Pharmacy_Profile.svg";

interface PharmacyInfo {
  pharmacyId: string;
  pharmacyName: string;
  hoursOfService: string;
  store: string;
  address: string;
  landMark: string;
  city: string;
  state: string;
  zip: string;
  phone: string;
  fax: string;
}

interface PharmacyInfoProps {
  PharmaInfo: PharmacyInfo;
}

const RxChangePharmacyInfo: React.FC<PharmacyInfoProps> = ({ PharmaInfo }) => {
  return (
    <>
      <Grid container xs={12} md={12} padding={0} marginBottom={2}>
        <CommonCard
          sx={{
            padding: "8px",
            border: "none",
            width: "100%",
            background: "#FFFFFF80",
          }}
          className="pharmacyInfo"
        >
          <Box className="title">
            <img
              src={PharmacyProfileIcon}
              alt="Pharmacy Profile"
              loading="lazy"
            />
            <Typography
              variant="caption"
              fontSize={14}
              fontWeight={400}
              color="primary"
              fontStyle={"normal"}
              component={"div"}
              width={{ sm: "auto", md: 100 }}
            >
              <strong> Pharmacy </strong> Information
            </Typography>
          </Box>
          <Box className="content">
            <Box>
              <Typography
                component="label"
                variant="body2"
                htmlFor="name"
                fontWeight={700}
              >
                Name:
              </Typography>
              <Typography component="div" variant="body2">
                {PharmaInfo?.pharmacyName ? PharmaInfo?.pharmacyName : "N/A"}
              </Typography>
            </Box>
            <Box>
              <Typography
                component="label"
                variant="body2"
                htmlFor="address"
                fontWeight={700}
              >
                Address:
              </Typography>
              <Typography component="div" variant="body2">
                {PharmaInfo?.address ? PharmaInfo?.address : "N/A"}
              </Typography>
            </Box>
            <Box className="sl">
              <Box>
                <Typography
                  component="label"
                  variant="body2"
                  htmlFor="zip"
                  fontWeight={700}
                >
                  Zip:
                </Typography>
                <Typography component="div" variant="body2">
                  {PharmaInfo?.zip ? PharmaInfo?.zip : "N/A"}
                </Typography>
              </Box>
              <Box>
                <Typography
                  component="label"
                  variant="body2"
                  htmlFor="city"
                  fontWeight={700}
                >
                  City:
                </Typography>
                <Typography component="div" variant="body2">
                  {PharmaInfo?.city ? PharmaInfo?.city : "N/A"}
                </Typography>
              </Box>
              <Box>
                <Typography
                  component="label"
                  variant="body2"
                  htmlFor="state"
                  fontWeight={700}
                >
                  State:
                </Typography>
                <Typography component="div" variant="body2">
                  {PharmaInfo?.state ? PharmaInfo?.state : "N/A"}
                </Typography>
              </Box>
            </Box>{" "}
            <Box className="sl">
              <Box>
                <Typography
                  component="label"
                  variant="body2"
                  htmlFor="phone"
                  fontWeight={700}
                >
                  Phone:
                </Typography>
                <Typography component="div" variant="body2">
                  {PharmaInfo?.phone ? PharmaInfo?.phone : "N/A"}
                </Typography>
              </Box>
              <Box>
                <Typography
                  component="label"
                  variant="body2"
                  htmlFor="fax"
                  fontWeight={700}
                >
                  Fax:
                </Typography>
                <Typography component="div" variant="body2">
                  {PharmaInfo?.fax ? PharmaInfo?.fax : "N/A"}
                </Typography>
              </Box>
            </Box>
          </Box>
        </CommonCard>
      </Grid>
    </>
  );
};

export default RxChangePharmacyInfo;
